export type BreakPoint = {
    gridGap: number,
    minWidth: number,
    padding: number,
    activeClass?: string
}

export type BreakPoints = {
    [key: string]: BreakPoint;
}

export const borderRadii = {
    xs: {value: '.5rem', px: 8},
    sm: {value: '.75rem', px: 12},
    md: {value: '1rem', px: 16},
    lg: {value: '1.5rem', px: 24},
    xl: {value: '2rem', px: 32},
    full: {value: '9999px'},
};

export const breakPoints: BreakPoints = {
    xs: {
        gridGap: 12,
        minWidth: 0,
        padding: 16,
    },
    sm: {
        gridGap: 20,
        minWidth: 768,
        padding: 24,
    },
    md: {
        gridGap: 20,
        minWidth: 1024,
        padding: 24,
    },
    lg: {
        gridGap: 32,
        minWidth: 1440,
        padding: 64,
    },
    xl: {
        gridGap: 32,
        minWidth: 1728,
        padding: 64,
    }
}

export const maxWidth = 1728;


// Formatted for Tailwind Config:

export const borderRadius = Object.fromEntries(
    Object.entries(borderRadii)
        .map(([key, value]) => [key, value.value])
);
borderRadius.DEFAULT =  borderRadii.xs.value;

export const container = {
    center: true,
    padding: Object.fromEntries(
        Object.entries(breakPoints).map(([key, value]) => [key, value.padding + 'px'])
    )
};

export const screens = Object.fromEntries(
    Object.entries(breakPoints)
        .map(([key, value]) => [key, value.minWidth + 'px'])
);